import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";

import type {IConsentTemplate} from "../types";
import {getConsentContent} from "../utils/get_consent_content";

interface IProps {
    template: IConsentTemplate;
    className?: string;
    privacyPolicyLink?: string;
}

export const DefaultConsentNotice = ({template, className, privacyPolicyLink}: IProps) => (
    <Text variant="info_txt_1" align="center" className={className}>
        {getConsentContent(template)}
        {privacyPolicyLink && (
            <>
                <br />
                <Link size="x-small" underline href={privacyPolicyLink} target="_blank">
                    Zasady przetwarzania danych osobowych
                </Link>
            </>
        )}
    </Text>
);
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";

import type {IConsentTemplate} from "../types";
import {getConsentContent} from "../utils/get_consent_content";

interface IProps {
    template: IConsentTemplate;
    className?: string;
    privacyPolicyLink?: string;
}

export const DefaultConsentNotice = ({template, className, privacyPolicyLink}: IProps) => (
    <Text variant="info_txt_1" align="center" className={className}>
        {getConsentContent(template)}
        {privacyPolicyLink && (
            <>
                <br />
                <Link size="x-small" underline href={privacyPolicyLink} target="_blank">
                    Zasady przetwarzania danych osobowych
                </Link>
            </>
        )}
    </Text>
);
